import { useEffect, useState } from 'react';

export function BotaoVoltarAoTopo() {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    function aoRolar() {
      setVisivel(window.scrollY > 480);
    }
    window.addEventListener('scroll', aoRolar);
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  if (!visivel) {
    return null;
  }

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Voltar ao topo"
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '92px',
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        background: 'var(--cor-branco)',
        color: 'var(--cor-primaria)',
        border: '1px solid var(--cor-borda)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 6px 16px rgba(16,32,61,0.18)',
        zIndex: 1000,
        cursor: 'pointer',
        fontSize: '18px',
        fontWeight: 700,
      }}
    >
      ↑
    </button>
  );
}
